import { render, staticRenderFns } from "./cargarDocumentos.vue?vue&type=template&id=5d14b9fa&"
import script from "./cargarDocumentos.vue?vue&type=script&lang=js&"
export * from "./cargarDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports